exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".payment-cards[data-v-01b9fccb] {\n  display: grid;\n  grid-template-columns: repeat(5, var(--size-xl));\n  gap: var(--size-xs);\n  height: 100%;\n  place-content: center;\n  justify-content: flex-end;\n}\n@media screen and (max-width: 992px) {\n.payment-cards[data-v-01b9fccb] {\n    grid-template-columns: repeat(5, var(--size-lg));\n}\n}\n.payment-cards > svg[data-v-01b9fccb] {\n  width: 100%;\n}", ""]);

// exports
